module.exports = __webpack_public_path__ + "static/logo-cass-ae3b3fcaca797ed8d770857ce27f0d33.png";